export default {
  HTTP_SERVER: 'https://easy-mock.com/mock/5b2e15c2d901cc25e7df4e0c',
  HTTP_PREFIX: '/travel'
}



// WEBPACK FOOTER //
// ./src/http/httpConfig.js